import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FolderTreeWrapper = styled.nav`
  flex: 1;
  min-height: 0;
  padding: ${Spacing.S16} ${Spacing.S8} ${Spacing.S16} ${Spacing.S16};
  overflow-y: auto;
`
